import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MessengerWidget from "./components/MessengerWidget";
import SEO from "./components/SEO";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Franchise from "./pages/Franchise";
import Resilience from "./pages/Resilience";
import Hardware from "./pages/Hardware";
import Contact from "./pages/Contact";
import Apply from "./pages/Apply";
import Terms from "./pages/Terms";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";

// AppRouter handles routing
function AppRouter() {
  const location = useLocation();
  
  // Check if we're on the admin route (no navbar/footer)
  const isAdminRoute = location.pathname === '/admin';
  
  return (
    <>
      <ScrollToTop />
      <SEO />
      {!isAdminRoute && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/franchise" element={<Franchise />} />
        <Route path="/resilience" element={<Resilience />} />
        <Route path="/hardware" element={<Hardware />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <MessengerWidget />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
